// extracted by mini-css-extract-plugin
export default {"text":"CampaignFilters_text__LiSYh","genericInput":"CampaignFilters_genericInput__fuha4"};